import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import samplePlans from '../../../../Api/samplePlans';

import { Save } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  FormControl,
  LinearProgress,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import segments from 'Api/segments';

const EditPlatekind = ({
  cancel,
  value,
  testId,
  reFetchProject,
  segmentId,
  projectId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const { handleSubmit, register, formState, errors } = useForm();

  const onSubmit = (data) => {
    setIsLoading(true);
    segments
      .updateSegment(segmentId, {
        testId: testId,
        plateKind: data.platekind,
      })
      .then(async () => {
        try {
          await samplePlans.removeSamplePlan(projectId);
        } catch (e) {
          console.log(e);
        }

        reFetchProject();
        cancel();
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const renderForm = () => {
    if (!isLoading) {
      return (
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl fullWidth>
            <TextField
              select
              focused
              variant="outlined"
              fullWidth
              label="Tag Series"
              defaultValue={value}
              {...register('platekind')}
              error={!!(errors && errors.platekind)}
              helperText={errors?.platekind?.message}
            >
              {['A', 'B'].map((value) => (
                <MenuItem key={value} value={value}>
                  <Typography>{value}</Typography>
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <Stack direction="row" justifyContent="space-between" mt={2}>
            <Button
              variant="contained"
              startIcon={<Save />}
              disabled={!formState.isDirty}
              type="submit"
            >
              Save
            </Button>
            <ButtonGroup>
              <Button onClick={cancel}>Cancel</Button>
            </ButtonGroup>
          </Stack>
        </form>
      );
    }
    return null;
  };

  return (
    <Stack p={2} spacing={2}>
      {isLoading && <LinearProgress />}
      <Typography variant="h5">Edit tag series</Typography>
      <Box py={2}>{renderForm()}</Box>
      {!!error && (
        <Alert severity="error">Error when updating tag series</Alert>
      )}
    </Stack>
  );
};

export default EditPlatekind;
